module.exports = __webpack_public_path__ + "img/more-bt-pink.551cd5f0.png";